import styled from 'styled-components';

interface IStyleProps {
    selectedTab?: string;
}

export const MainContainer = styled.nav`
    margin: 0px 0px 0px 0px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
    background-color: #f8f8f8;
    display: flex;
    padding: 12px 0px 0px 0px;
`;


export const WidgetsContainer = styled.nav`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    position: ${(props: IStyleProps) => (props.selectedTab==='entire' ? 'relative' : '')};
`;
